import { ValuationApproachModel } from 'api';
import { VALUATIONS_PUBLIC_COMPANIES_APPROACH } from 'pages/ValuationsAllocation/common/constants/valuations';

/**
 * Parameters for updating GPC approach settings from dialog.
 */
export interface UpdatePublicCompsApproachSettingsParams {
  updatedApproach: ValuationApproachModel;
  isEvaluatingEquityValue: boolean;
  useMultiplePremiumDiscount: boolean;
  useForwardMultipleDiscount: boolean;
}

/**
 * Updates public comps approach settings from dialog values.
 * Applies equity option, premium/discount, and forward multiple settings.
 *
 * @param params - Approach and new settings from dialog
 * @returns Updated approach with new public comps settings
 */
export const updatePublicCompsApproachSettings = (
  params: UpdatePublicCompsApproachSettingsParams
): ValuationApproachModel => {
  const { updatedApproach, isEvaluatingEquityValue, useMultiplePremiumDiscount, useForwardMultipleDiscount } = params;

  const approach = { ...updatedApproach };

  if (approach.approach_type === VALUATIONS_PUBLIC_COMPANIES_APPROACH) {
    approach.valuations_approach_gpc!.is_evaluating_equity_value = isEvaluatingEquityValue;
    approach.valuations_approach_gpc!.use_multiple_premium_discount = useMultiplePremiumDiscount;
    approach.valuations_approach_gpc!.use_forward_multiple_discount = useForwardMultipleDiscount;
  }

  return approach;
};
